import { render, staticRenderFns } from "./Booking4.vue?vue&type=template&id=bb09911c&"
import script from "./Booking4.vue?vue&type=script&lang=ts&"
export * from "./Booking4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports